document.addEventListener('DOMContentLoaded', function () {

  function calculateHMSleft() {
    var d = new Date();
    var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var monthday = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var now = new Date();

    // Function to update both elements for time and delivery day
    function updateElements(HMSremainingId, deliverydayId) {
      if (d.getDay() >= 1 && d.getDay() <= 5) {
        var hoursleft = 17 - now.getHours();
        var minutesleft = 59 - now.getMinutes();
        var secondsleft = 59 - now.getSeconds();

        //format 0 prefixes
        if (minutesleft < 10) minutesleft = "0" + minutesleft;
        if (secondsleft < 10) secondsleft = "0" + secondsleft;

        if (hoursleft < 0) {
          hoursleft += 24;
        }

        //display time left
        if (hoursleft > 0) {
          document.getElementById(HMSremainingId).innerHTML = hoursleft + " hours and " + minutesleft + " minutes";
        } else {
          document.getElementById(HMSremainingId).innerHTML = minutesleft + " minutes";
        }

        // Calculate delivery day for weekdays
        if (hoursleft > 17) {
          if (d.getDay() >= 1 && d.getDay() <= 4) {
            d.setHours(d.getHours() + 48);
          } else if (d.getDay() == 5) {
            d.setHours(d.getHours() + 72);
          }
        } else {
          d.setHours(d.getHours() + 24);
        }
        var deliver = weekday[d.getDay()];
        var day = d.getDate();
        var month = monthday[d.getMonth()];
        document.getElementById(deliverydayId).innerHTML = deliver + ' ' + month + ' ' + day;

      } else if (d.getDay() == 0 || d.getDay() == 6) { // WEEKEND
        var hoursleft = 10 - now.getHours();
        var minutesleft = 59 - now.getMinutes();
        var secondsleft = 59 - now.getSeconds();

        //format 0 prefixes
        if (minutesleft < 10) minutesleft = "0" + minutesleft;
        if (secondsleft < 10) secondsleft = "0" + secondsleft;

        if (hoursleft < 0) {
          hoursleft += 24;
        }

        //display time left
        if (hoursleft > 0) {
          document.getElementById(HMSremainingId).innerHTML = hoursleft + " hours and " + minutesleft + " minutes";
        } else {
          document.getElementById(HMSremainingId).innerHTML = minutesleft + " minutes";
        }

        // Calculate delivery day for weekends
        if (hoursleft > 10) {
          d.setHours(d.getHours() + (d.getDay() == 6 ? 48 : 24));
        } else {
          d.setHours(d.getHours() + (d.getDay() == 6 ? 48 : 24));
        }
        var deliver = weekday[d.getDay()];
        var day = d.getDate();
        var month = monthday[d.getMonth()];
        document.getElementById(deliverydayId).innerHTML = deliver + ' ' + month + ' ' + day;
      }
    }

    // Update both sets of IDs
    updateElements('HMSremaining1', 'deliveryday1');
    updateElements('HMSremaining2', 'deliveryday2');
  }

  calculateHMSleft();
  setInterval(calculateHMSleft, 60000);

});
